type BankLogoProps = {
  src: string;
  height?: string;
  width?: string;
  style?: React.CSSProperties;
};

export default function BankLogo({
  src,
  height = '35px',
  width = '35px',
  style = {},
}: BankLogoProps) {
  return (
    <img
      alt="bank logo"
      style={{
        height,
        width,
        ...style,
      }}
      src={src}
    />
  );
}
